import React from "react";
import type { HeroSlide } from "../../../data/site";
import { SlideTitle } from "./SlideTitle";
import { SmartSpeaker } from "./SmartSpeaker";
import { DroneMotor } from "./DroneMotor";
export function ProductSlide({
  slide,
  active
}: {
  slide: HeroSlide;
  active: boolean;
}) {
  const product = slide.product === "speaker" ? <SmartSpeaker active={active} data-id="element-429" data-mp="houxgwviz7h3" /> : <DroneMotor active={active} data-id="element-430" data-mp="hq618woz0f87" />;
  const actions = <div className="mt-6 flex flex-wrap justify-center gap-3 lg:justify-start" data-id="element-431" data-mp="mm4js3nmb30p">
      <a href={slide.primary.href} tabIndex={active ? 0 : -1} className="whitespace-nowrap rounded-full bg-ink px-6 py-3 text-[13px] font-semibold uppercase tracking-wide text-sun transition-[transform,background-color] duration-150 ease-out hover:bg-ink/85 active:scale-[0.97]" data-id="element-432" data-mp="rlr6d3pc5vm6">
        {slide.primary.label}
      </a>
      {slide.secondary && <a href={slide.secondary.href} tabIndex={active ? 0 : -1} className="whitespace-nowrap rounded-full border-2 border-ink px-6 py-2.5 text-[13px] font-semibold uppercase tracking-wide transition-colors duration-150 hover:bg-ink hover:text-sun" data-id="element-433" data-mp="32ebz1gw71ly2">
          {slide.secondary.label}
        </a>}
    </div>;
  if (slide.layout === "stacked") {
    return (
      // Title pinned to the top and copy to the bottom; the motor takes the space between.
      <div className="flex h-full flex-col gap-4 pb-6 pt-2 md:pt-4" data-id="element-434" data-mp="1dyv08s44hj1m">
        {/* Sized so the longest line ("No prior hardware experience.") always fits on one row; capped by height on desktop. */}
        <SlideTitle lines={slide.title} active={active} align="center" className="text-[6vw] md:text-[clamp(2rem,6vw,5.5rem)] lg:text-[clamp(2rem,min(6vw,8svh),5.5rem)]" data-id="element-435" data-mp="14y6lfv6wneno" />
        {/* The drawing grows to fill whatever height the slide has, so no dead bands above or below. */}
        <figure className="flex min-h-0 w-full flex-1 flex-col" data-id="element-436" data-mp="3kp1dkv6isrqz">
          <div className="flex min-h-0 flex-1 items-center justify-center" data-id="element-437" data-mp="3m6gkk3avr5hz">{product}</div>
          <figcaption className="mt-1 text-center text-[12px] font-semibold uppercase tracking-wide text-ink/60" data-id="element-438" data-mp="3m4ndwo09ol9z">
            {slide.figure}
          </figcaption>
        </figure>
        <div className="mx-auto flex max-w-2xl flex-col items-center pb-2 text-center" data-id="element-439" data-mp="3d5ifrismatyc">
          <p className="text-[16px] font-medium leading-relaxed text-ink/80" data-id="element-440" data-mp="3i3bke7e9vfwi">{slide.body}</p>
          <div className="[&>div]:justify-center" data-id="element-441" data-mp="33f70x17eb0co">{actions}</div>
        </div>
      </div>
    );
  }
  return (
    // On desktop the speaker fills the slide's height and the text block centres against it.
    <div className="grid h-full items-center gap-4 pb-6 pt-2 md:pt-4 lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[minmax(0,1fr)] lg:gap-10 lg:pb-14" data-id="element-442" data-mp="2ugvcn5u04ene">
      <div className="text-center lg:text-left" data-id="element-443" data-mp="2khe6knau7yqw">
        <SlideTitle lines={slide.title} active={active} align="left" className="text-[clamp(3.2rem,8.5vw,8.5rem)] lg:text-[clamp(3.2rem,min(8.5vw,10svh),8.5rem)]" data-id="element-444" data-mp="2khmlekqite4q" />
        <div data-id="element-445" data-mp="25tw1vox9z44h">
          <p className="mx-auto mt-6 max-w-md text-[16px] font-medium leading-relaxed text-ink/80 lg:ml-0" data-id="element-446" data-mp="25vgs52ck40wj">{slide.body}</p>
          {actions}
        </div>
      </div>
      <figure className="mx-auto flex w-full max-w-[270px] flex-col sm:max-w-[360px] lg:min-h-0 lg:max-w-none lg:self-stretch" data-id="element-447" data-mp="2fsbrtokkg7ce">
        <div className="min-h-0 lg:flex-1" data-id="element-448" data-mp="2asgzdgl579p8">{product}</div>
        <figcaption className="-mt-4 text-center text-[12px] font-semibold uppercase tracking-wide text-ink/60" data-id="element-449" data-mp="2ot9x0a6qqkwk">
          {slide.figure}
        </figcaption>
      </figure>
    </div>
  );
}